// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"03b90142","186":"208779d9","272":"e6d2b6d9","372":"2885606d","738":"e93e5e73","841":"9c2b15ed","851":"9e152ae6","856":"85f874e3"}[chunkId] + ".chunk.js";
};